/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addInventory } from '../fn/inventory/add-inventory';
import { AddInventory$Params } from '../fn/inventory/add-inventory';
import { addInventoryStockTake } from '../fn/inventory/add-inventory-stock-take';
import { AddInventoryStockTake$Params } from '../fn/inventory/add-inventory-stock-take';
import { addInventoryWriteOff } from '../fn/inventory/add-inventory-write-off';
import { AddInventoryWriteOff$Params } from '../fn/inventory/add-inventory-write-off';
import { addPurchaseOrder } from '../fn/inventory/add-purchase-order';
import { AddPurchaseOrder$Params } from '../fn/inventory/add-purchase-order';
import { addStockItem } from '../fn/inventory/add-stock-item';
import { AddStockItem$Params } from '../fn/inventory/add-stock-item';
import { addStockTransfer } from '../fn/inventory/add-stock-transfer';
import { AddStockTransfer$Params } from '../fn/inventory/add-stock-transfer';
import { cancelInventoryStockTake } from '../fn/inventory/cancel-inventory-stock-take';
import { CancelInventoryStockTake$Params } from '../fn/inventory/cancel-inventory-stock-take';
import { cancelPurchaseOrder } from '../fn/inventory/cancel-purchase-order';
import { CancelPurchaseOrder$Params } from '../fn/inventory/cancel-purchase-order';
import { cancelStockTransfer } from '../fn/inventory/cancel-stock-transfer';
import { CancelStockTransfer$Params } from '../fn/inventory/cancel-stock-transfer';
import { completeInventoryStockTake } from '../fn/inventory/complete-inventory-stock-take';
import { CompleteInventoryStockTake$Params } from '../fn/inventory/complete-inventory-stock-take';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { UnitMeasurmentEnumTypesDto as DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto } from '../models/Digiwork/MaitreD/Pos/DTO/EnumTypes/unit-measurment-enum-types-dto';
import { InventoriesDto as DigiworkMaitreDPosDtoInventoryInventoriesDto } from '../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventories-dto';
import { InventoryDto as DigiworkMaitreDPosDtoInventoryInventoryDto } from '../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { InventoryStockDto as DigiworkMaitreDPosDtoInventoryInventoryStockDto } from '../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-stock-dto';
import { InventoryStockItemsDto as DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto } from '../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-stock-items-dto';
import { InventoryStockTakeDto as DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto } from '../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';
import { InventoryStockTakesDto as DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto } from '../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-takes-dto';
import { InventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto } from '../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';
import { InventoryStockTransfersDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto } from '../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfers-dto';
import { PurchaseOrderDto as DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto } from '../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';
import { PurchaseOrdersDto as DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto } from '../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-orders-dto';
import { StockItemDto as DigiworkMaitreDPosDtoStockItemStockItemDto } from '../models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { StockItemsDto as DigiworkMaitreDPosDtoStockItemStockItemsDto } from '../models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-items-dto';
import { InventoryWriteOffDto as DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto } from '../models/Digiwork/MaitreD/Pos/DTO/WriteOffs/inventory-write-off-dto';
import { InventoryWriteOffsDto as DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto } from '../models/Digiwork/MaitreD/Pos/DTO/WriteOffs/inventory-write-offs-dto';
import { getInventories } from '../fn/inventory/get-inventories';
import { GetInventories$Params } from '../fn/inventory/get-inventories';
import { getInventory } from '../fn/inventory/get-inventory';
import { GetInventory$Params } from '../fn/inventory/get-inventory';
import { getInventoryStockItems } from '../fn/inventory/get-inventory-stock-items';
import { GetInventoryStockItems$Params } from '../fn/inventory/get-inventory-stock-items';
import { getInventoryStockTake } from '../fn/inventory/get-inventory-stock-take';
import { GetInventoryStockTake$Params } from '../fn/inventory/get-inventory-stock-take';
import { getInventoryStockTakes } from '../fn/inventory/get-inventory-stock-takes';
import { GetInventoryStockTakes$Params } from '../fn/inventory/get-inventory-stock-takes';
import { getInventoryWriteOffs } from '../fn/inventory/get-inventory-write-offs';
import { GetInventoryWriteOffs$Params } from '../fn/inventory/get-inventory-write-offs';
import { getMeasurementUnitTypes } from '../fn/inventory/get-measurement-unit-types';
import { GetMeasurementUnitTypes$Params } from '../fn/inventory/get-measurement-unit-types';
import { getPurchaseOrder } from '../fn/inventory/get-purchase-order';
import { GetPurchaseOrder$Params } from '../fn/inventory/get-purchase-order';
import { getPurchaseOrders } from '../fn/inventory/get-purchase-orders';
import { GetPurchaseOrders$Params } from '../fn/inventory/get-purchase-orders';
import { getStockItem } from '../fn/inventory/get-stock-item';
import { GetStockItem$Params } from '../fn/inventory/get-stock-item';
import { getStockItems } from '../fn/inventory/get-stock-items';
import { GetStockItems$Params } from '../fn/inventory/get-stock-items';
import { getStockTransfer } from '../fn/inventory/get-stock-transfer';
import { GetStockTransfer$Params } from '../fn/inventory/get-stock-transfer';
import { getStockTransfers } from '../fn/inventory/get-stock-transfers';
import { GetStockTransfers$Params } from '../fn/inventory/get-stock-transfers';
import { receivePurchaseOrder } from '../fn/inventory/receive-purchase-order';
import { ReceivePurchaseOrder$Params } from '../fn/inventory/receive-purchase-order';
import { receiveStockTransfer } from '../fn/inventory/receive-stock-transfer';
import { ReceiveStockTransfer$Params } from '../fn/inventory/receive-stock-transfer';
import { removeInventory } from '../fn/inventory/remove-inventory';
import { RemoveInventory$Params } from '../fn/inventory/remove-inventory';
import { removeStockItem } from '../fn/inventory/remove-stock-item';
import { RemoveStockItem$Params } from '../fn/inventory/remove-stock-item';
import { restockInventoryItem } from '../fn/inventory/restock-inventory-item';
import { RestockInventoryItem$Params } from '../fn/inventory/restock-inventory-item';
import { updateInventory } from '../fn/inventory/update-inventory';
import { UpdateInventory$Params } from '../fn/inventory/update-inventory';
import { updateInventoryStockTake } from '../fn/inventory/update-inventory-stock-take';
import { UpdateInventoryStockTake$Params } from '../fn/inventory/update-inventory-stock-take';
import { updatePurchaseOrder } from '../fn/inventory/update-purchase-order';
import { UpdatePurchaseOrder$Params } from '../fn/inventory/update-purchase-order';
import { updateStockItem } from '../fn/inventory/update-stock-item';
import { UpdateStockItem$Params } from '../fn/inventory/update-stock-item';
import { updateStockTransfer } from '../fn/inventory/update-stock-transfer';
import { UpdateStockTransfer$Params } from '../fn/inventory/update-stock-transfer';

@Injectable({ providedIn: 'root' })
export class InventoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getInventories()` */
  static readonly GetInventoriesPath = '/api/inventories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventories$Response(params?: GetInventories$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoriesDto>> {
    return getInventories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventories(params?: GetInventories$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryInventoriesDto> {
    return this.getInventories$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoriesDto>): DigiworkMaitreDPosDtoInventoryInventoriesDto => r.body)
    );
  }

  /** Path part for operation `addInventory()` */
  static readonly AddInventoryPath = '/api/inventories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addInventory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInventory$Response(params?: AddInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>> {
    return addInventory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addInventory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInventory(params?: AddInventory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryInventoryDto> {
    return this.addInventory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>): DigiworkMaitreDPosDtoInventoryInventoryDto => r.body)
    );
  }

  /** Path part for operation `getInventory()` */
  static readonly GetInventoryPath = '/api/inventories/{inventoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventory$Response(params: GetInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>> {
    return getInventory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventory(params: GetInventory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryInventoryDto> {
    return this.getInventory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>): DigiworkMaitreDPosDtoInventoryInventoryDto => r.body)
    );
  }

  /** Path part for operation `updateInventory()` */
  static readonly UpdateInventoryPath = '/api/inventories/{inventoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventory$Response(params: UpdateInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>> {
    return updateInventory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInventory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventory(params: UpdateInventory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryInventoryDto> {
    return this.updateInventory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>): DigiworkMaitreDPosDtoInventoryInventoryDto => r.body)
    );
  }

  /** Path part for operation `removeInventory()` */
  static readonly RemoveInventoryPath = '/api/inventories/{inventoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeInventory()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeInventory$Response(params: RemoveInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeInventory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeInventory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeInventory(params: RemoveInventory$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeInventory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getMeasurementUnitTypes()` */
  static readonly GetMeasurementUnitTypesPath = '/api/stock-items/measurement-units';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMeasurementUnitTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeasurementUnitTypes$Response(params?: GetMeasurementUnitTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto>> {
    return getMeasurementUnitTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMeasurementUnitTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMeasurementUnitTypes(params?: GetMeasurementUnitTypes$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto> {
    return this.getMeasurementUnitTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto>): DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto => r.body)
    );
  }

  /** Path part for operation `getStockItems()` */
  static readonly GetStockItemsPath = '/api/stock-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStockItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockItems$Response(params?: GetStockItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemsDto>> {
    return getStockItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStockItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockItems(params?: GetStockItems$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoStockItemStockItemsDto> {
    return this.getStockItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemsDto>): DigiworkMaitreDPosDtoStockItemStockItemsDto => r.body)
    );
  }

  /** Path part for operation `addStockItem()` */
  static readonly AddStockItemPath = '/api/stock-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addStockItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addStockItem$Response(params?: AddStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>> {
    return addStockItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addStockItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addStockItem(params?: AddStockItem$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoStockItemStockItemDto> {
    return this.addStockItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>): DigiworkMaitreDPosDtoStockItemStockItemDto => r.body)
    );
  }

  /** Path part for operation `getStockItem()` */
  static readonly GetStockItemPath = '/api/stock-items/{stockItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStockItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockItem$Response(params: GetStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>> {
    return getStockItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStockItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockItem(params: GetStockItem$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoStockItemStockItemDto> {
    return this.getStockItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>): DigiworkMaitreDPosDtoStockItemStockItemDto => r.body)
    );
  }

  /** Path part for operation `updateStockItem()` */
  static readonly UpdateStockItemPath = '/api/stock-items/{stockItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStockItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStockItem$Response(params: UpdateStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>> {
    return updateStockItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStockItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStockItem(params: UpdateStockItem$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoStockItemStockItemDto> {
    return this.updateStockItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>): DigiworkMaitreDPosDtoStockItemStockItemDto => r.body)
    );
  }

  /** Path part for operation `removeStockItem()` */
  static readonly RemoveStockItemPath = '/api/stock-items/{stockItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeStockItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeStockItem$Response(params: RemoveStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeStockItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeStockItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeStockItem(params: RemoveStockItem$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeStockItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getInventoryWriteOffs()` */
  static readonly GetInventoryWriteOffsPath = '/api/inventories/{inventoryId}/write-offs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventoryWriteOffs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryWriteOffs$Response(params: GetInventoryWriteOffs$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto>> {
    return getInventoryWriteOffs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventoryWriteOffs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryWriteOffs(params: GetInventoryWriteOffs$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto> {
    return this.getInventoryWriteOffs$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto>): DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffsDto => r.body)
    );
  }

  /** Path part for operation `addInventoryWriteOff()` */
  static readonly AddInventoryWriteOffPath = '/api/inventories/{inventoryId}/write-offs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addInventoryWriteOff()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInventoryWriteOff$Response(params: AddInventoryWriteOff$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto>> {
    return addInventoryWriteOff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addInventoryWriteOff$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInventoryWriteOff(params: AddInventoryWriteOff$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto> {
    return this.addInventoryWriteOff$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto>): DigiworkMaitreDPosDtoWriteOffsInventoryWriteOffDto => r.body)
    );
  }

  /** Path part for operation `getInventoryStockTakes()` */
  static readonly GetInventoryStockTakesPath = '/api/inventories/{inventoryId}/stock-takes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventoryStockTakes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryStockTakes$Response(params: GetInventoryStockTakes$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto>> {
    return getInventoryStockTakes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventoryStockTakes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryStockTakes(params: GetInventoryStockTakes$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto> {
    return this.getInventoryStockTakes$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto>): DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto => r.body)
    );
  }

  /** Path part for operation `addInventoryStockTake()` */
  static readonly AddInventoryStockTakePath = '/api/inventories/{inventoryId}/stock-takes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addInventoryStockTake()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInventoryStockTake$Response(params: AddInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
    return addInventoryStockTake(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addInventoryStockTake$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInventoryStockTake(params: AddInventoryStockTake$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto> {
    return this.addInventoryStockTake$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>): DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto => r.body)
    );
  }

  /** Path part for operation `getInventoryStockTake()` */
  static readonly GetInventoryStockTakePath = '/api/inventories/{inventoryId}/stock-takes/{stockTakeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventoryStockTake()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryStockTake$Response(params: GetInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
    return getInventoryStockTake(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventoryStockTake$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryStockTake(params: GetInventoryStockTake$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto> {
    return this.getInventoryStockTake$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>): DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto => r.body)
    );
  }

  /** Path part for operation `updateInventoryStockTake()` */
  static readonly UpdateInventoryStockTakePath = '/api/inventories/{inventoryId}/stock-takes/{stockTakeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventoryStockTake()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryStockTake$Response(params: UpdateInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
    return updateInventoryStockTake(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInventoryStockTake$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryStockTake(params: UpdateInventoryStockTake$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto> {
    return this.updateInventoryStockTake$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>): DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto => r.body)
    );
  }

  /** Path part for operation `completeInventoryStockTake()` */
  static readonly CompleteInventoryStockTakePath = '/api/inventories/{inventoryId}/stock-takes/{stockTakeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `completeInventoryStockTake()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeInventoryStockTake$Response(params: CompleteInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
    return completeInventoryStockTake(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `completeInventoryStockTake$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeInventoryStockTake(params: CompleteInventoryStockTake$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto> {
    return this.completeInventoryStockTake$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>): DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto => r.body)
    );
  }

  /** Path part for operation `getPurchaseOrders()` */
  static readonly GetPurchaseOrdersPath = '/api/inventories/{inventoryId}/purchase-orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrders$Response(params: GetPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto>> {
    return getPurchaseOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrders(params: GetPurchaseOrders$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto> {
    return this.getPurchaseOrders$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto>): DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto => r.body)
    );
  }

  /** Path part for operation `addPurchaseOrder()` */
  static readonly AddPurchaseOrderPath = '/api/inventories/{inventoryId}/purchase-orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addPurchaseOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addPurchaseOrder$Response(params: AddPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
    return addPurchaseOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addPurchaseOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addPurchaseOrder(params: AddPurchaseOrder$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto> {
    return this.addPurchaseOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>): DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto => r.body)
    );
  }

  /** Path part for operation `getPurchaseOrder()` */
  static readonly GetPurchaseOrderPath = '/api/inventories/{inventoryId}/purchase-orders/{purchaseOrderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrder$Response(params: GetPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
    return getPurchaseOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrder(params: GetPurchaseOrder$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto> {
    return this.getPurchaseOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>): DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto => r.body)
    );
  }

  /** Path part for operation `updatePurchaseOrder()` */
  static readonly UpdatePurchaseOrderPath = '/api/inventories/{inventoryId}/purchase-orders/{purchaseOrderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePurchaseOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePurchaseOrder$Response(params: UpdatePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
    return updatePurchaseOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePurchaseOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePurchaseOrder(params: UpdatePurchaseOrder$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto> {
    return this.updatePurchaseOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>): DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto => r.body)
    );
  }

  /** Path part for operation `receivePurchaseOrder()` */
  static readonly ReceivePurchaseOrderPath = '/api/inventories/{inventoryId}/purchase-orders/{purchaseOrderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receivePurchaseOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receivePurchaseOrder$Response(params: ReceivePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
    return receivePurchaseOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receivePurchaseOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receivePurchaseOrder(params: ReceivePurchaseOrder$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto> {
    return this.receivePurchaseOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>): DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto => r.body)
    );
  }

  /** Path part for operation `cancelInventoryStockTake()` */
  static readonly CancelInventoryStockTakePath = '/api/inventories/{inventoryId}/stock-takes/{stockTakeId}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelInventoryStockTake()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelInventoryStockTake$Response(params: CancelInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
    return cancelInventoryStockTake(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelInventoryStockTake$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelInventoryStockTake(params: CancelInventoryStockTake$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto> {
    return this.cancelInventoryStockTake$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>): DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto => r.body)
    );
  }

  /** Path part for operation `cancelPurchaseOrder()` */
  static readonly CancelPurchaseOrderPath = '/api/inventories/{inventoryId}/purchase-orders/{purchaseOrderId}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelPurchaseOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelPurchaseOrder$Response(params: CancelPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
    return cancelPurchaseOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelPurchaseOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelPurchaseOrder(params: CancelPurchaseOrder$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto> {
    return this.cancelPurchaseOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>): DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto => r.body)
    );
  }

  /** Path part for operation `getStockTransfers()` */
  static readonly GetStockTransfersPath = '/api/inventories/{inventoryId}/transfers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStockTransfers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockTransfers$Response(params: GetStockTransfers$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto>> {
    return getStockTransfers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStockTransfers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockTransfers(params: GetStockTransfers$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto> {
    return this.getStockTransfers$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto>): DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto => r.body)
    );
  }

  /** Path part for operation `addStockTransfer()` */
  static readonly AddStockTransferPath = '/api/inventories/{inventoryId}/transfers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addStockTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addStockTransfer$Response(params: AddStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
    return addStockTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addStockTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addStockTransfer(params: AddStockTransfer$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto> {
    return this.addStockTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>): DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto => r.body)
    );
  }

  /** Path part for operation `cancelStockTransfer()` */
  static readonly CancelStockTransferPath = '/api/inventories/{inventoryId}/transfers/{transferId}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelStockTransfer()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelStockTransfer$Response(params: CancelStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
    return cancelStockTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelStockTransfer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelStockTransfer(params: CancelStockTransfer$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto> {
    return this.cancelStockTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>): DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto => r.body)
    );
  }

  /** Path part for operation `getStockTransfer()` */
  static readonly GetStockTransferPath = '/api/inventories/{inventoryId}/transfers/{transferId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStockTransfer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockTransfer$Response(params: GetStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
    return getStockTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStockTransfer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStockTransfer(params: GetStockTransfer$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto> {
    return this.getStockTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>): DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto => r.body)
    );
  }

  /** Path part for operation `updateStockTransfer()` */
  static readonly UpdateStockTransferPath = '/api/inventories/{inventoryId}/transfers/{transferId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStockTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStockTransfer$Response(params: UpdateStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
    return updateStockTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStockTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStockTransfer(params: UpdateStockTransfer$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto> {
    return this.updateStockTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>): DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto => r.body)
    );
  }

  /** Path part for operation `receiveStockTransfer()` */
  static readonly ReceiveStockTransferPath = '/api/inventories/{inventoryId}/transfers/{transferId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveStockTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveStockTransfer$Response(params: ReceiveStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
    return receiveStockTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveStockTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveStockTransfer(params: ReceiveStockTransfer$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto> {
    return this.receiveStockTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>): DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto => r.body)
    );
  }

  /** Path part for operation `restockInventoryItem()` */
  static readonly RestockInventoryItemPath = '/api/inventories/{inventoryId}/stock/{stockItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restockInventoryItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  restockInventoryItem$Response(params: RestockInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockDto>> {
    return restockInventoryItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restockInventoryItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  restockInventoryItem(params: RestockInventoryItem$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryInventoryStockDto> {
    return this.restockInventoryItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockDto>): DigiworkMaitreDPosDtoInventoryInventoryStockDto => r.body)
    );
  }

  /** Path part for operation `getInventoryStockItems()` */
  static readonly GetInventoryStockItemsPath = '/api/inventories/{inventoryId}/stock';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventoryStockItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryStockItems$Response(params: GetInventoryStockItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto>> {
    return getInventoryStockItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventoryStockItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryStockItems(params: GetInventoryStockItems$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto> {
    return this.getInventoryStockItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto>): DigiworkMaitreDPosDtoInventoryInventoryStockItemsDto => r.body)
    );
  }

}
